exports.DEFAULT_COMPRESSION_LEVEL = 3;
exports.STREAMING_DEFAULT_BUFFER_SIZE = 512 * 1024;
